import { useEffect, useRef, useState } from "react";
import TagsAutocomplete from "./TagsAutocomplete";
import { Tags } from "../../../services/Tags";

interface TagsAutocompleteWrapperProps {
  setTagsStorage: (tags:string) => void;
  tagsStorage?: string;
}

function TagsAutocompleteWrapper(props: TagsAutocompleteWrapperProps) {
  const { setTagsStorage, tagsStorage } = props;
  const [mostFrequentTags, setMostFrequentTags] = useState([]);
  const tagsRef = useRef(null);
  const [selected, setSelected] = useState<string[]>(tagsStorage ? tagsStorage.split(",") : []);

  const handleTagsChange = (value:string[]) => {
    setSelected(value);
    setTagsStorage(value.join(","));
  }

  const handleTagsKeyDown = (e:any) => {
    if (e.code === "Tab" || e.code === "Enter" || e.code === "Space" || e.code === "Comma" || e.code === "NumpadEnter") {
      e.preventDefault();
      tagsRef.current.setState({...tagsRef.current.state, text: ""});
      const newTag = (e.target as HTMLInputElement).value;
      if (newTag.length) {
        const currentTags = [...selected];
        if (currentTags.includes(newTag)) {
          currentTags.splice(currentTags.indexOf(newTag), 1);
        }
        handleTagsChange([...currentTags, newTag]);
      }
    }
  }

  useEffect(() => {
    Tags.getMostFrequentTags(setMostFrequentTags)
  }, []);

  return (<TagsAutocomplete
            onChange={(e:any) => handleTagsChange(e.map((tag:any) => tag.label ? tag.label : tag))}
            onKeyDown={(e) => handleTagsKeyDown(e)}
            options={mostFrequentTags}
            selected={selected}
            reactRef={tagsRef}
          />);
}

export default TagsAutocompleteWrapper;
